export default class PageSpinner {
    constructor() {
        ko.components.register('page-spinner', {
            viewModel: function PageSpinnerViewModel() {
            },
            template: `
                <div class="position-fixed d-flex justify-content-center align-items-center page-spinner">
                    <div class="spinner-border"></div>
                </div>
            `
        });
    }
}
